import React from "react"
import styled from "@emotion/styled"
import { Flex, Box } from "@rebass/grid/emotion"
import { TextElementNova } from "@nutrafol/nutrafol-ui-kit/dist/TextElementNova"
import RecurringIcon from "../../../../../../assets/icons/nova/recurring.svg"

const Wrap = styled(Flex)`
  align-items: center;

  .Serum {
    transform: translateY(-6px);
  }
`
const Info = styled(Flex)`
  flex-direction: column;
  gap: 4px;
`

const Tag = styled(Flex)`
  flex-direction: row;
  gap: 8px;
  align-items: center;
  width: fit-content;

  .shipping-copy {
    //min-height: 14px;
  }

  .shipping-icon {
    padding-bottom: 3px;
  }
`

const CoreUpsellRow = ({ item }) => {
  const {
    image,
    price,
    old_price,
    name,
    info,
    shipping,
    shippingIcon = true,
  } = item

  const SHIPPING = shipping ? (
    <Tag className={`bg-nova-base-solid-10`} p={[8]} mt={[8]}>
      {shippingIcon ? (
        <Box className={`shipping-icon`}>
          <RecurringIcon />
        </Box>
      ) : null}

      <Box className={`shipping-copy`}>
        <TextElementNova
          text={shipping}
          className={`Caption-10-Dia-Normal text-nova-base-black`}
        />
      </Box>
    </Tag>
  ) : null

  const widthPrama = image.url?.includes("ctfassets") ? "w" : "width"

  const sfx = image.url?.includes("?")
    ? `&${widthPrama}=240`
    : `?${widthPrama}=240`

  return (
    <Box>
      <Wrap ml={[0]}>
        <Box width={[80]}>
          <img src={image.url + sfx} alt={``} className={name} />
        </Box>
        <Info flex={1} pl={[24]}>
          <Flex width={[1]}>
            <Box>
              <TextElementNova text={name} className={`Body-20-Dia-Strong`} />
            </Box>
            <Box ml={["auto"]}>
              <TextElementNova
                text={`$${price}`}
                className={`Body-20-Dia-Strong`}
              />
            </Box>
          </Flex>
          <Box width={[1]}>
            <Flex>
              <Box>
                <TextElementNova
                  text={info}
                  className={`Body-10-Dia-Normal text-nova-transparency-black-60`}
                />
              </Box>
              {old_price ? (
                <Box ml={["auto"]}>
                  <TextElementNova
                    text={`$${old_price}`}
                    className={`Body-10-Dia-Normal text-nova-transparency-black-60 line-through`}
                  />
                </Box>
              ) : null}
            </Flex>
          </Box>
          <Box className={`show-md-up`}>{SHIPPING}</Box>
        </Info>
      </Wrap>
      <Box className={`hide-md-up`}>{SHIPPING}</Box>
    </Box>
  )
}

export default CoreUpsellRow
